import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";

@Component({
  selector: "order-reserve-online",
  templateUrl: "./reserve-online.component.html",
  styleUrls: ["./reserve-online.component.scss"],
})
export class ReserveOnlineComponent extends BaseListComponent {
  columns: form_control[] = [];
  constructor() {
    super();
  }

  ngOnInit() {
    this.setColumns();
    super.ngOnInit();
  }

  setColumns() {
    var col: form_control[] = [];
    col = [
      {
        name: "ReserveId",
        modelName: "ReserveId",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: `${this.translate("ClientApp.FrontOffice.Order.ReserveOnline.InvoiceNumber")} ReservID`,
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "InputNumber",
        modelName: "InputNumber",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.SubscriptionCode"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 150,
      },
      {
        name: "WaiterName",
        modelName: "WaiterName",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.GuestName"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "NumberOfPeople",
        modelName: "NumberOfPeople",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.NumberOfPeople"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 150,
      },
      {
        name: "UseCredit",
        modelName: "UseCredit",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.ClubCredit"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "Prepayment",
        modelName: "Prepayment",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.AdvancePayment"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "Mobile",
        modelName: "Mobile",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.Mobile"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "TableTitle",
        modelName: "TableTitle",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.TableTitle"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 200,
      },
      {
        name: "ReservationDay",
        modelName: "ReservationDay",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.BookingDay"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 150,
      },
      {
        name: "ReservationTime",
        modelName: "ReservationTime",
        controlType: FormControlTypes.dropdown,
        listVisible: true,
        label: this.translate("ClientApp.FrontOffice.Order.ReserveOnline.BookingTime"),
        order: 0,
        textType: "number",
        formVisible: true,
        disabled: false,
        areaName: "default",
        apiName: "",
        displayMember: "DisplayName",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
        columnWidth: 150,
      },
    ];
    this.columns = col;
    this.orignalColumns = col;
  }
}
